import React from "react"
import * as Icon from "react-feather"

const horizontalMenuConfig = [
  {
    id: "home",
    title: "Home",
    type: "item",
    icon: <Icon.Home size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/home",
  },
  {
    id: "patient",
    title: "Patient",
    type: "item",
    icon: <Icon.User size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/patient",
  },

  {
    id: "provider",
    title: "Provider",
    type: "item",
    icon: <Icon.Activity size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/provider",
  },
  {
    id: "insurance",
    title: "Insurance",
    type: "item",
    icon: <Icon.Thermometer size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/insurance",
  },
  {
    id: "specimen",
    title: "Specimen",
    type: "item",
    icon: <Icon.Underline size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/specimen",
    children: [
      {
        id: "specimen_info",
        title: "Specimen Info",
        type: "item",
        icon: <Icon.Circle size={12} />,
        permissions: ["admin", "editor"],
        navLink: "/specimen-info"
      },
      {
        id: "stain_detail",
        title: "Stain Detail",
        type: "item",
        icon: <Icon.Circle size={12} />,
        permissions: ["admin", "editor"],
        navLink: "/stain-details"
      },
    ]
  },
  {
    id: "tests",
    title: "Results",
    type: "item",
    icon: <Icon.CheckCircle size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/results",
    children: [
      {
        id: "results",
        title: "Diagnosis",
        type: "item",
        icon: <Icon.Circle size={12} />,
        permissions: ["admin", "editor"],
        navLink: "/results"
      },
      {
        id: "fishscoring",
        title: "FISH Scoring",
        type: "item",
        icon: <Icon.Circle size={12} />,
        permissions: ["admin", "editor"],
        navLink: "/fishscoring"
      },
    ]
  },
  {
    id: "casedocuments",
    title: "Documents",
    type: "item",
    icon: <Icon.Clipboard size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/documents",
    children: [
      {
        id: "documents",
        title: "Documents",
        type: "item",
        icon: <Icon.Circle size={12} />,
        permissions: ["admin", "editor"],
        navLink: "/documents"
      },
      {
        id: "patient_aor",
        title: "Patient AOR Document",
        type: "item",
        icon: <Icon.Circle size={12} />,
        permissions: ["admin", "editor"],
        navLink: "/patient-aor"
      },
      {
        id: "casereport",
        title: "Case Report Document",
        type: "item",
        icon: <Icon.Circle size={12} />,
        permissions: ["admin", "editor"],
        navLink: "/caseReportDocument"
      },
      // {
      //   id: "upload",
      //   title: "Upload Final Report",
      //   type: "item",
      //   icon: <Icon.Circle size={12} />,
      //   permissions: ["admin", "editor"],
      //   navLink: "/UploadFinalReport"
      // }
      {
        id: "upload",
        title: "Upload Ventana Report",
        type: "item",
        icon: <Icon.Circle size={12} />,
        permissions: ["admin", "editor"],
        navLink: "/uploadVentanaReport"
      }
    ]
   },
]

export default horizontalMenuConfig
